const draftWorkflowRoutes = [
  '/welcome-questionnaire', '/document-library', '/document-builder',
  '/assigned-documents', '/lawyer-management', '/assigned-questionnaires'
];

/** Routes an owner can use while the welcome questionnaire is still in progress. */
export const isDraftWorkflowRoute = (pathname: string): boolean =>
  draftWorkflowRoutes.some(path => pathname === path || pathname.startsWith(path + '/'));
